module.exports = __webpack_public_path__ + "e712ac4b7c796153d28e4ac02fecd12c.svg";